/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SavedViewSummary
 */
export interface SavedViewSummary {
  /**
   *
   * @type {string}
   * @memberof SavedViewSummary
   */
  savedViewId: string;
  /**
   *
   * @type {string}
   * @memberof SavedViewSummary
   */
  viewType: string;
  /**
   *
   * @type {string}
   * @memberof SavedViewSummary
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof SavedViewSummary
   */
  description?: string | null;
  /**
   *
   * @type {string}
   * @memberof SavedViewSummary
   */
  ownerEmail: string;
  /**
   *
   * @type {boolean}
   * @memberof SavedViewSummary
   */
  isOwner: boolean;
  /**
   *
   * @type {boolean}
   * @memberof SavedViewSummary
   */
  isFollowing: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof SavedViewSummary
   */
  followers: Array<string>;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof SavedViewSummary
   */
  createdAt: OffsetDateTime;
}

/**
 * Check if a given object implements the SavedViewSummary interface.
 */
export function instanceOfSavedViewSummary(
  value: object,
): value is SavedViewSummary {
  if (!("savedViewId" in value) || value["savedViewId"] === undefined)
    return false;
  if (!("viewType" in value) || value["viewType"] === undefined) return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("ownerEmail" in value) || value["ownerEmail"] === undefined)
    return false;
  if (!("isOwner" in value) || value["isOwner"] === undefined) return false;
  if (!("isFollowing" in value) || value["isFollowing"] === undefined)
    return false;
  if (!("followers" in value) || value["followers"] === undefined) return false;
  if (!("createdAt" in value) || value["createdAt"] === undefined) return false;
  return true;
}

export function SavedViewSummaryFromJSON(json: any): SavedViewSummary {
  return SavedViewSummaryFromJSONTyped(json, false);
}

export function SavedViewSummaryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SavedViewSummary {
  if (json == null) {
    return json;
  }
  return {
    savedViewId: json["savedViewId"],
    viewType: json["viewType"],
    name: json["name"],
    description: json["description"] == null ? undefined : json["description"],
    ownerEmail: json["ownerEmail"],
    isOwner: json["isOwner"],
    isFollowing: json["isFollowing"],
    followers: json["followers"],
    createdAt: json["createdAt"],
  };
}

export function SavedViewSummaryToJSON(json: any): SavedViewSummary {
  return SavedViewSummaryToJSONTyped(json, false);
}

export function SavedViewSummaryToJSONTyped(
  value?: SavedViewSummary | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    savedViewId: value["savedViewId"],
    viewType: value["viewType"],
    name: value["name"],
    description: value["description"],
    ownerEmail: value["ownerEmail"],
    isOwner: value["isOwner"],
    isFollowing: value["isFollowing"],
    followers: value["followers"],
    createdAt: value["createdAt"],
  };
}
